var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapPinOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 19.4398L10.5481 18.9612C15.1572 14.9366 17.5 11.4225 17.5 8.3335C17.5 3.95905 14.0858 0.833496 10 0.833496C5.91421 0.833496 2.5 3.95905 2.5 8.3335C2.5 11.4225 4.84276 14.9366 9.45189 18.9612L10 19.4398ZM10 17.2197C6.08884 13.6948 4.16667 10.7079 4.16667 8.3335C4.16667 4.914 6.80343 2.50016 10 2.50016C13.1966 2.50016 15.8333 4.914 15.8333 8.3335C15.8333 10.7079 13.9112 13.6948 10 17.2197ZM10 4.16683C12.3012 4.16683 14.1667 6.03231 14.1667 8.3335C14.1667 10.6347 12.3012 12.5002 10 12.5002C7.69881 12.5002 5.83333 10.6347 5.83333 8.3335C5.83333 6.03231 7.69881 4.16683 10 4.16683ZM7.5 8.3335C7.5 6.95278 8.61929 5.8335 10 5.8335C11.3807 5.8335 12.5 6.95278 12.5 8.3335C12.5 9.71421 11.3807 10.8335 10 10.8335C8.61929 10.8335 7.5 9.71421 7.5 8.3335Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinOutlined);
export default __webpack_public_path__ + "static/media/map-pin-outlined.9cabfb5c.svg";
export { ForwardRef as ReactComponent };